export function SAVE_USER_DATA(state, [address, birthday, email, full_name]){
    state.address = address
    state.birthday = birthday
    state.email = email
    state.full_name = full_name
}